// Action Creators
import {
  addSpatial,
  updateSpatial,
  removeSpatial,
  createSpatial,
  editSpatial,
  clearSelectedSpatial,
  submitSpatial,
  toggleEditingSpatial,
  submitChangesToSpatial,
  toggleActiveToolsOp,
} from '../actions'

// Selctors

import selectedSpatial$ from '../selectors/selectedSpatial'

// Libs
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// Exports
export function mapStateToProps (state) {
  return {
    selectedSpatial: selectedSpatial$(state),
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    addSpatial,
    updateSpatial,
    removeSpatial,
    createSpatial,
    editSpatial,
    clearSelectedSpatial,
    submitSpatial,
    toggleEditingSpatial,
    submitChangesToSpatial,
    toggleActiveToolsOp,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)
